/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Email_Template_ArchivedInputs */

const en_error_email_template_archived = /** @type {(inputs: Error_Email_Template_ArchivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This email is archived: bring it back to change it.`)
};

/**
* | output |
* | --- |
* | "This email is archived: bring it back to change it." |
*
* @param {Error_Email_Template_ArchivedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_email_template_archived = /** @type {((inputs?: Error_Email_Template_ArchivedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Email_Template_ArchivedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_email_template_archived(inputs)
});